// Darstellung (System/Hell/Dunkel) — Master = mobile App.
// Standard (:root) ist dunkel; `html.light` überschreibt auf helles Theme.
const KEY = "voyalyo_theme";
const VALID = ["system", "light", "dark"];

export function getStoredTheme() {
  const v = localStorage.getItem(KEY);
  return VALID.includes(v) ? v : "system";
}

function effective(mode) {
  if (mode === "system") {
    return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
  }
  return mode;
}

export function applyTheme(mode) {
  const root = document.documentElement;
  if (effective(mode) === "light") root.classList.add("light");
  else root.classList.remove("light");
}

export function setTheme(mode) {
  const m = VALID.includes(mode) ? mode : "system";
  localStorage.setItem(KEY, m);
  applyTheme(m);
}

export function initTheme() {
  applyTheme(getStoredTheme());
  const mq = window.matchMedia("(prefers-color-scheme: light)");
  mq.addEventListener("change", () => {
    if (getStoredTheme() === "system") applyTheme("system");
  });
}
